
import { CircleOutlined, CheckCircleOutlineOutlined } from '@mui/icons-material';
import { Typography, ListItem } from '@mui/material';


export default function AnswerOption(props) {

    const {answer, lang, includesAnswer, handleAnswerClick} = props;

    const text = answer.text[lang];

    if (!includesAnswer) {
        return(
            <ListItem key={text} onClick={() => handleAnswerClick(answer)} button
                sx={{
                    width: "100%",
                    justifyContent: "left",
                    alignItems: "center",
                    margin: "auto",
                    marginBottom: 2,
                    backgroundColor: "secondary.lighter",
                    '&:hover': {
                        backgroundColor: "secondary.lighter",
                    },
                }}
            >
                <CircleOutlined sx={{marginRight: "1rem"}}/>
                <Typography>
                    {text}
                </Typography>
            </ListItem>
        ) 
    } else {
        return(
            <ListItem key={text} onClick={() => handleAnswerClick(answer)} button
                        sx={{
                            width: "100%",
                            justifyContent: "left",
                            alignItems: "center",
                            margin: "auto",
                            marginBottom: 2,
                            backgroundColor: "secondary.main",
                            '&:hover': {
                                backgroundColor: "secondary.lighter",
                            },
                        }}
                    >
                        <CheckCircleOutlineOutlined sx={{marginRight: "1rem"}}/>
                        <Typography>
                            {text}
                        </Typography>
                    </ListItem>
        )
    }
}